import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import clarity from '@microsoft/clarity';

const projectId = process.env.VUE_APP_CLARITY_ID;

// TODO: descomentar quando for subir para produção
// if (process.env.VUE_APP_ENV === 'production') {
  clarity.init(projectId);
//}

createApp(App).use(router).use(i18n).mount('#app')
